import { createContext } from '@wordpress/element';
export const CircularOptionPickerContext = createContext({});
CircularOptionPickerContext.displayName = 'CircularOptionPickerContext';